import React from 'react';
import {
  Card,
  CardLeft,
  IconWrapper,
  Info,
  Label,
  Value,
  ArrowIconWrapper,
} from './RecordCard.styled';
import {
  ArrowRightIcon,
} from '../../../../../../components/Icons';

export interface TrainingBathCardProps {
  /** アイコン要素（運動） */
  icon1?: React.ReactNode;
  /** ラベル（例: 運動） */
  label1?: string;
  /** サブラベル（オプション） */
  subLabel1?: string;
  /** 値（例: 実施） */
  value1?: string | number;
  /** 単位（例: ℃、mmHg） */
  unit1?: string;
  /** アイコン要素（入浴） */
  icon2?: React.ReactNode;
  /** ラベル（例: 入浴） */
  label2?: string;
  /** サブラベル（オプション） */
  subLabel2?: string;
  /** 値（例: 実施） */
  value2?: string | number;
  /** 単位（例: ℃、mmHg） */
  unit2?: string;
  /** クリックハンドラ */
  onClick?: () => void;
  /** クリック可能か */
  clickable?: boolean;
}

/**
 * TrainingBathCard（Molecule）
 * 機能訓練・入浴情報を表示するカードコンポーネント
 * 2つのアイコンと情報を横並びで表示
 */
export const TrainingBathCard: React.FC<TrainingBathCardProps> = ({
  icon1,
  label1,
  value1,
  icon2,
  label2,
  value2,
  onClick,
  clickable = true,
}) => {
  // キーボード操作対応
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (clickable && onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  // アクセシビリティ用のラベルテキスト
  const ariaLabel = `${label1}: ${value1}${value2 ? `, ${value2}` : ''}${clickable ? '。詳細を表示' : ''}`;

  // 項目1（運動）を表示するか
  const showItem1 = icon1 && label1 && value1 !== undefined;
  // 項目2（入浴）を表示するか
  const showItem2 = icon2 && label2 && value2 !== undefined;

  return (
    <Card
      onClick={clickable ? onClick : undefined}
      onKeyDown={handleKeyDown}
      tabIndex={clickable ? 0 : undefined}
      role={clickable ? 'button' : 'group'}
      aria-label={ariaLabel}
      $clickable={clickable}
    >
      {showItem1 && (
        <CardLeft>
          <IconWrapper aria-hidden="true">{icon1}</IconWrapper>
          <Info>
            <Label>{label1}</Label>
            <Value $isSmallFontSize={true}>{value1}</Value>
          </Info>
        </CardLeft>
      )}
      {showItem2 && (
        <CardLeft>
          <IconWrapper aria-hidden="true">{icon2}</IconWrapper>
          <Info>
            <Label>{label2}</Label>
            <Value $isSmallFontSize={true}>{value2}</Value>
          </Info>
        </CardLeft>
      )}
      {clickable && <ArrowIconWrapper><ArrowRightIcon /></ArrowIconWrapper>}
    </Card>
  );
};

export default TrainingBathCard;
